import cn from 'classnames';

import LogoAuraDarkMode from '../assets/logo-aura-white.svg';
import LogoAura from '../assets/logo-aura.svg';
import { useDarkMode } from '../hooks/use-dark-mode';

export function AuraLogo({ className }: { className?: string }) {
  const isDarkMode = useDarkMode();
  const classes = cn('h-6', className);

  return (
    <img src={isDarkMode ? LogoAuraDarkMode : LogoAura} alt="Neo4j Aura logo" className={classes} draggable={false} />
  );
}
